import React from 'react';
import { locale } from '@tcc/i18n';
import { getMessage } from 'util/locale';
import { formatDate } from 'util/formatters/dateFormatter';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Timestamp = ({
  timestamp
}) => {

  const classString = classNames({
    'vra-timestamp': true
  });

  return (
    <section className={classString} data-test-id="script-time-stamp">
      { timestamp 
        ? <div>
          <label className='vra-timestamp__label'>{getMessage('label-text__last-edited')}</label> 
          { formatDate(timestamp, { locale }) }
        </div>
        : ''
      }
    </section>
  );
};

Timestamp.propTypes = {
  timestamp: PropTypes.string.isRequired
};

export default Timestamp;
